import { render, staticRenderFns } from "./tixian.vue?vue&type=template&id=c47cd61e&scoped=true"
import script from "./tixian.vue?vue&type=script&lang=js"
export * from "./tixian.vue?vue&type=script&lang=js"
import style0 from "./tixian.vue?vue&type=style&index=0&id=c47cd61e&prod&lang=scss&scoped=true"
import style1 from "./tixian.vue?vue&type=style&index=1&id=c47cd61e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47cd61e",
  null
  
)

export default component.exports